/**
 * Hardcoded group options per categoryId.
 * If a categoryId is not listed here, the admin can type a free-form group name.
 */
export const CATEGORY_GROUPS = {
  hair_care: ["Haircut", "Hair Styling", "Hair Wash"],
  hair_removal: ["Waxing", "Threading"],
  massage_spa: ["Massage", "Spa"],
  manicure_pedicure: ["Manicure", "Pedicure"],
  package: ["Combo"],
  beard_shave: ["Beard", "Shave"],
  cleanup_detan: ["Cleanup", "Detan"],
};

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "unisex", label: "Unisex" },
];
